import axios from "axios";
import { useGlobalLoader } from "vue-app/composables/useGlobalLoader";

const { hideGlobalLoader } = useGlobalLoader();

export default {
  initAudience({ commit, state, dispatch }, { isDev, engagementTypeId, timezone }) {
    commit("setIsDev", { isDev });
    commit("setEngagementTypeId", { engagementTypeId });
    commit("setTimezone", { timezone });
    commit("setCountTotalCustomers", { countTotalCustomers: null });
    commit("setEngagement", { engagement: null });

    axios
      .post("/json/engagements/initAudience", {
        engagement_type_id: engagementTypeId,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
            hideGlobalLoader();
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setTagList", { tagList: res.tagList });
        commit("setTagArray", { tagArray: res.tagArray });
        commit("setIsRfmEnabled", { isRfmEnabled: res.isRfmEnabled });
        commit("setCustomerCustomList", {
          customerCustomList: res.customerCustomList,
        });
        commit("setEngagementParameters", {
          engagementParameters: res.engagementParameters,
        });
        if (engagementTypeId === 13) {
          res.engagement.engagement.customerListTypeId = 0;
        }
        commit("setEngagement", { engagement: res.engagement.engagement });
        dispatch("loadTotalCustomers");

        if (engagementTypeId === 11) {
          axios
            .get("/json/engagements/getCustomFieldsAudience?engagement_id=" + res.engagement.engagement.engagementId)
            .then((res) => res)
            .then(
              (json) =>
                new Promise((resolve, reject) => {
                  const data = json.data.data;
                  commit("setCustomFieldsAudience", {
                    customFieldsAudience: data,
                  });
                })
            )
            .catch((err) => {
              console.log(err);
            });
        }
      });

    if (engagementTypeId === 11) {
      axios
        .get("/json/engagements/getListOfAllValuesForColumnAndCountThem?name=first_name")
        .then((res) => res)
        .then(
          (json) =>
            new Promise((resolve, reject) => {
              const data = json.data.data;
              commit("setCustomAudienceFirstNameList", {
                customAudienceFirstNameList: data,
              });
            })
        )
        .catch((err) => {
          console.log(err);
        });

      axios
        .get("/json/engagements/getListOfAllValuesForColumnAndCountThem?name=city")
        .then((res) => res)
        .then(
          (json) =>
            new Promise((resolve, reject) => {
              const data = json.data.data;
              commit("setCustomAudienceCityList", {
                customAudienceCityList: data,
              });
            })
        )
        .catch((err) => {
          console.log(err);
        });

      axios
        .get("/json/engagements/getListOfAllValuesForColumnAndCountThem?name=country")
        .then((res) => res)
        .then(
          (json) =>
            new Promise((resolve, reject) => {
              const data = json.data.data;
              commit("setCustomAudienceCountryList", {
                customAudienceCountryList: data,
              });
            })
        )
        .catch((err) => {
          console.log(err);
        });

      axios
        .get("/json/engagements/getListOfAllValuesForColumnAndCountThem?name=browser_language")
        .then((res) => res)
        .then(
          (json) =>
            new Promise((resolve, reject) => {
              const data = json.data.data;
              commit("setCustomAudienceBrowserLangaugeList", {
                customAudienceBrowserLangaugeList: data,
              });
            })
        )
        .catch((err) => {
          console.log(err);
        });
    }
  },
  updateAudience(
    { commit, state, dispatch },
    { customer_list_type_id, tags_array, tagged_type_id, custom_customer_list_type_id, customer_custom_list_id }
  ) {
    commit("setIsLoading", { isLoading: true });
    axios
      .post("/engagements/updateAudience", {
        customer_list_type_id: customer_list_type_id,
        tag_array: tags_array.join(","),
        tagged_type_id: tagged_type_id,
        engagement_type_id: state.engagementTypeId,
        custom_customer_list_type_id: custom_customer_list_type_id,
        customer_custom_list_id: customer_custom_list_id,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        window.showToast("Error", "error");
        return {};
      })
      .then((res) => {
        window.showToast("Updated", "success");
        dispatch("loadCustomerAudienceCustomers", { timeout: 1000 });
      });
  },
  updateAudienceSendSubscriptionType({ commit, state, dispatch }, { send_subscription_type }) {
    commit("setIsLoading", { isLoading: true });
    axios
      .post("/engagements/updateAudienceSendSubscriptionType", {
        send_subscription_type: send_subscription_type,
        engagement_type_id: state.engagementTypeId,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        window.showToast("Error", "error");
        return {};
      })
      .then((res) => {
        window.showToast("Updated", "success");
        dispatch("loadCustomerAudienceCustomers", { timeout: 1000 });
      });
  },
  loadTotalCustomers({ commit, state, dispatch }) {
    axios
      .post("/json/engagements/getCountTotalCustomers")
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        const data = res.data;
        commit("setCountTotalCustomers", { countTotalCustomers: data });
      });
  },
  loadCustomerAudienceCustomers({ commit, state, dispatch }, { timeout }) {
    if (state.cancelToken) {
      state.cancelToken.abort();
      console.log("cancel");
    }
    let controller = new AbortController();
    commit("setCancelToken", { cancelToken: controller });
    commit("setIsLoading", { isLoading: true });
    axios
      .post(
        "/json/engagements/getCountAudienceCustomers",
        {
          engagement_id: state.engagement.engagementId,
        },
        {
          signal: controller.signal,
        }
      )
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        const data = res.data;
        commit("setCountAudienceCustomers", { countAudienceCustomers: data });
        commit("setIsLoading", { isLoading: false });
      });
  },
  updateEngagementParameterWithEngagementId(
    { commit, state, dispatch },
    { engagement_id, engagement_parameter_type_id, value, is_null }
  ) {
    commit("setIsLoading", { isLoading: true });
    axios
      .post("/engagements/updateEngagementParameterWithEngagementId", {
        engagement_id: engagement_id,
        engagement_parameter_type_id: engagement_parameter_type_id,
        value: value,
        is_null: is_null,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        window.showToast("Error", "error");
        return {};
      })
      .then((res) => {
        window.showToast("Updated", "success");
        dispatch("loadCustomerAudienceCustomers", { timeout: 1000 });
      });
  },
  async getEngagementParameterWithEngagementId(
    { commit, state, dispatch },
    { engagement_id, engagement_parameter_type_id }
  ) {
    let response = null;
    await axios
      .post("/engagements/getEngagementParameterWithEngagementId", {
        engagement_id: engagement_id,
        engagement_parameter_type_id: engagement_parameter_type_id,
      })
      .then((res) => res)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        response = res.data;
      });
    return response;
  },
};
